import React from 'react';
import { IconButton as StyledIconButton } from './IconButton.styles';

export interface IconButtonProps {
  /**
   * Icon component to be used in the button.
   */
  icon: React.JSX.Element;
  /**
   * Optional click handler.
   */
  onClick?: () => void;
  style?: React.CSSProperties;
  testId?: string;
  disabled?: boolean;
  size?: 'small' | 'medium' | 'large';
}

/**
 * Icon buttons in Open Reporting.
 */
export const IconButton: React.FC<IconButtonProps> = ({
  onClick,
  icon,
  disabled,
  size,
  ...props
}: IconButtonProps) => {
  return (
    <StyledIconButton onClick={onClick} disabled={disabled} {...props}>
      {icon}
    </StyledIconButton>
  );
};

export default IconButton;
